<script setup lang="ts">
import { AppBackground } from '@haskoning/vue-component-library'
import { useRoute } from 'vue-router'
import { useProjectStore } from '@/stores/project'
import { useScenarioStore } from '@/stores/scenario'
import { useProjectUserStore } from '@/stores/projectUser'
import { useAuthorizationStore } from '@/stores/authorization'
import { useDjangoAuthStore } from '@/stores/authDjango'
import { onMounted, onUnmounted } from 'vue'
import _ from 'lodash'
import type { ProjectUserType } from '@/stores/type/projectUser.type'
import { storeToRefs } from 'pinia'

const route = useRoute()

const projectStore = useProjectStore()
const scenarioStore = useScenarioStore()

const authStore = useDjangoAuthStore()
const projectUserStore = useProjectUserStore()
const authorizationStore = useAuthorizationStore()

const { currentItem: currentProjectItem } = storeToRefs(projectStore)
const { currentItem: currentCalculationItem } = storeToRefs(scenarioStore)
const { items: projectUsers } = storeToRefs(projectUserStore)
const { user: currentUser } = storeToRefs(authStore)

onMounted(async () => {
  if (!currentProjectItem.value || _.isEmpty(currentProjectItem.value)) {
    await projectStore.fetchOptions()
    const projectId = route.params.id as string
    await projectStore.fetchItem(parseInt(projectId))
  }

  if (currentProjectItem.value) {
    const { id } = currentProjectItem.value

    if (id) {
      await projectUserStore.fetchItems({ search: id })
      await authorizationStore.fetchItems()

      const currentProjectUser = projectUsers.value.find(
        (item: ProjectUserType) => item.user === currentUser?.value?.id
      ) as ProjectUserType
      authorizationStore.setCurrentRole([currentProjectUser?.role])
    }
  }

  if (!currentCalculationItem.value || _.isEmpty(currentCalculationItem.value)) {
    await scenarioStore.fetchOptions()
    const scenarioId = route.params.scenarioId as string
    await scenarioStore.fetchItem(parseInt(scenarioId))
  }
})

onUnmounted(() => {
  projectStore.resetAll()
  scenarioStore.resetAll()
})
</script>

<template>
  <div style="display: flex; flex-direction: column" class="fill-height">
    <AppBackground>
      <router-view></router-view>
    </AppBackground>
  </div>
</template>

<style scoped></style>
